export default {
      id: "ic_caret_down_red-usage",
      viewBox: "0 0 16 12",
      url: "/" + "images/icons.3.109.2.svg#ic_caret_down_red-usage",
      toString: function () {
        return this.url;
      }
    }